import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import React from "react";
import { Provider } from "react-redux";
import { Navigate } from "react-router-dom";

import { SpinnerWrapper } from "@components/common/SpinnerWrapper";
import { CustomErrorBoundary } from "@components/CustomErrorBoundary";
import store from "@components/OrderTaking/Store";

import { Kiosk } from "@pages/Kiosk";

const queryClient = new QueryClient();

const Layout = React.lazy(() => import("@components/Layout"));

export const routes = [
    {
        element: (
            <React.Suspense fallback={<SpinnerWrapper />}>
                <Layout />
            </React.Suspense>
        ),
        children: [
            {
                path: "/",
                element: (
                    <Provider store={store}>
                        <QueryClientProvider client={queryClient}>
                            <CustomErrorBoundary>
                                <Kiosk />
                            </CustomErrorBoundary>
                        </QueryClientProvider>
                    </Provider>
                ),
            },
        ],
    },
    {
        path: "*",
        element: <Navigate to="/" />,
    },
];
